const DEMO_LOGINS = ['admin@blackhorsetrans.com'];

export default {
  DEMO_LOGINS,
};
